import styled from 'styled-components';

import { Button } from '@simplywallst/ui-core';

export const TextContainer = styled('div')`
  padding-bottom: ${({ theme }) => theme.x2spacePx}px;
`;

export const CenteredButton = styled(Button)`
  text-align: center;
`;
